const agenda = [
	{
		path: '/tv/agenda/week',
		name: 'tv-agenda-week',
		component: () => import('@/views/tv/agenda/week.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
]

export default agenda
